import script from "./dashbInstituteSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashbInstituteSettings.vue?vue&type=script&setup=true&lang=ts"

import "./dashbInstituteSettings.vue?vue&type=style&index=0&id=1395561b&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1395561b"]])

export default __exports__